import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IRequestResult } from "app/common/interfaces";
import { environment as evn } from "environments/environment.prod";

const apiUrl = evn.API_AVE_TRIP_URL;
const moduleName = "trip-visit-order";

/** Una entrada guardada del orden de visita de un viaje (`prc-trip-visit-order`). */
export interface VisitOrderEntry {
  position: number;
  businessPartnerMongoId: string;
  businessPartnerAddressMongoId: string;
}

/** Cuerpo de `PUT trip-visit-order/:tripId` — sin `position`, se recalcula server-side. */
export interface VisitOrderEntryInput {
  businessPartnerMongoId: string;
  businessPartnerAddressMongoId: string;
}

/** `prc-trip-visit-order` completo de un viaje. */
export interface TripVisitOrder {
  tripMongoId: string;
  visitOrder: VisitOrderEntry[];
}

/**
 * Consume `GET`/`PUT trip-visit-order/:tripId` (ave-trip, fs-98-trip-visit-order-crud).
 * No extiende `AbstractService`: son dos operaciones puntuales sobre un
 * sub-recurso del viaje, no un CRUD completo.
 */
@Injectable({
  providedIn: "root",
})
export class TripVisitOrderService {
  constructor(private readonly http: HttpClient) {}

  /**
   * `null` si el viaje no tiene orden de visita propio guardado todavía.
   *
   * `silent` suprime el overlay global (`x-ave-ctx: skip-loading`): el chequeo
   * de pisada del gestor de confirmación corre de fondo, con su propio estado.
   * El editor de trips (su otro consumidor) sigue con el overlay por defecto.
   */
  findByTrip(
    tripMongoId: string,
    silent: boolean = false,
  ): Observable<IRequestResult<TripVisitOrder | null>> {
    const API_URL = `${apiUrl}api/${moduleName}/${tripMongoId}`;
    return this.http.get<IRequestResult<TripVisitOrder | null>>(
      API_URL,
      silent ? { headers: { 'x-ave-ctx': 'skip-loading' } } : {},
    );
  }

  /** Reemplaza el array completo, en el orden recibido. */
  replace(
    tripMongoId: string,
    entries: VisitOrderEntryInput[],
  ): Observable<IRequestResult<TripVisitOrder>> {
    const API_URL = `${apiUrl}api/${moduleName}/${tripMongoId}`;
    return this.http.put<IRequestResult<TripVisitOrder>>(API_URL, { entries });
  }
}
